import { createBrowserHistory } from 'history';

var res = document.getElementsByTagName('base');
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
export default createBrowserHistory({
    basename: baseUrl
});
